module.exports = __webpack_public_path__ + "media/src/images/favicon/android-chrome-192x192-9bdede6d4118772a8e2bbda04f01824a.png";